import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { UserForm, UpdateUserFormData } from './UserForm';
import { User } from '@console/utils';
import { UpdateUserDto } from '@/lib/api/users';

export interface UpdateUserModalProps extends BaseModalProps {
  user: User;
  onUpdate: (id: string, data: UpdateUserDto) => Promise<boolean>;
  isUpdating: boolean;
}

export function UpdateUserModal({
  open,
  onOpenChange,
  user,
  onUpdate,
  isUpdating,
}: UpdateUserModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: UpdateUserFormData) => {
    const success = await onUpdate(user.id, {
      email: data.email,
      name: data.name,
      role: data.role,
      groupId: data.groupId,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t('users.updateModal.title', 'Editar Usuário')}
    >
      <UserForm
        mode="update"
        onSubmit={handleSubmit}
        isLoading={isUpdating}
        initialData={{
          name: user.name,
          email: user.email,
          role: user.role,
          groupId: user.groupId,
        }}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
